module.exports = __webpack_public_path__ + "static/media/gps-icon.eeab54fa.svg";